<template>
  <div class="handover">
    <el-divider content-position="left" style="font-size: 0.28rem">工作交接</el-divider>
    <el-row>
      <el-col :span="2">
        <a href="/handover_rec">
          <el-button type="primary" size="mini" title="打开交接记录">交接记录</el-button>
        </a>
      </el-col>
    </el-row>
    <el-dialog title="导入信息" :visible.sync="dialogFormVisible">
      <div style="padding: 0.5rem 1rem">
        <p style="color: #409eff; font-size: medium">
          本次共导入成功<strong>{{ importNum }}</strong
          >条数据
        </p>
        <p style="color: #f56c6c; font-size: small; margin-top: 0.2rem">
          失败<strong>{{ importArr.length }}</strong
          >条
          <el-button
            style="margin-left: 0.2rem"
            size="mini"
            type="warning"
            @click.native="exportFail"
            >导出失败数据</el-button
          >
        </p>
        <p style="color: #f56c6c; font-size: small; margin-top: 0.2rem">
          失败原因:公司名称与系统中的不匹配!
        </p>
        <el-row style="margin-top: 0.2rem">
          <el-col
            style="margin-top: 0.1rem"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="{ span: '4-8' }"
            :xl="6"
            v-for="(item, index) in importArr"
            :key="index"
          >
            <el-tooltip class="item" effect="dark" :content="item" placement="top">
              <span
                style="
                  display: inline-block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 200px;
                "
                >{{ item }}</span
              >
            </el-tooltip></el-col
          >
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">重新导入</el-button>
        <el-button
          type="primary"
          size="mini"
          :disabled="importIds.length === 0"
          @click="goOnSearch"
          >忽略，继续查询</el-button
        >
      </div>
    </el-dialog>
    <el-drawer
      title="未完成的待办事项"
      :visible.sync="unMatterOveredDrawer"
      direction="rtl"
      size="50%"
      @close="closeUnMatterOveredDrawer"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-table
          :data="unMatterOveredData"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
          max-height="650"
        >
          <el-table-column
            prop="company.company_name"
            label="公司名称"
            width="220"
            fixed="left"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.company.company_name"
                placement="top"
              >
                <el-link
                  style="
                    display: block;
                    color: #409eff;
                    font-size: 0.28rem;
                    cursor: pointer;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                  @click="openCompanyCom_a(scope.row)"
                >
                  {{ scope.row.company.company_name }}
                </el-link>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="复制" placement="top"
                ><i
                  class="el-icon-document-copy"
                  style="margin-left: 0.1rem; cursor: pointer"
                  @click="copySome(scope.row.company.company_name)"
                ></i
              ></el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="typeiner.username" label="创建人" width="150">
            <template slot-scope="scope">
              <p>{{ scope.row.typeiner.username }}</p>
              <p>{{ scope.row.created_at }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="completed_at" label="ETA处理时间" width="280">
          </el-table-column>
          <el-table-column prop="donner.username" label="办理人" width="120">
            <template slot-scope="scope">
              <div v-if="!scope.row.overTime">
                <span v-if="!scope.row.donner">
                  <!-- <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="点击添加办理人"
                      placement="top"
                    >
                      <el-popover
                        placement="left-start"
                        width="300"
                        trigger="click"
                      >
                        <el-form
                          :model="addAddressForm"
                          :rules="addressRules"
                          ref="addAddressForm"
                          label-width="80px"
                          style="padding-right: 0.33rem"
                        >
                          <el-form-item label="办理人" prop="doner_id">
                            <el-select
                              v-model="addAddressForm.doner_id"
                              placeholder="请选择"
                              size="mini"
                              @click.native="loadAdminUser_a"
                              filterable
                              style="width: 100%"
                              clearable
                            >
                              <el-option
                                v-for="item in adminUserOptions_a"
                                :key="item.id"
                                :label="item.username"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <div
                          style="
                            margin-top: 0.15rem;
                            text-align: right;
                            padding-right: 0.33rem;
                          "
                        >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="saveChange('addAddressForm', scope.row.id)"
                            >保存
                          </el-button>
                        </div>
                        <i
                          slot="reference"
                          style="
                            cursor: pointer;
                            font-size: 0.38rem;
                            color: #409eff;
                          "
                          class="el-icon-circle-plus-outline"
                        ></i>
                      </el-popover>
                    </el-tooltip>
                  </span> -->
                </span>
                <span v-else>
                  <span>
                    {{ scope.row.donner.username }}
                  </span>
                </span>
              </div>
              <div v-if="scope.row.overTime">
                <span v-if="!scope.row.donner">
                  <!-- <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="点击添加办理人"
                      placement="top"
                    >
                      <el-popover
                        placement="left-start"
                        width="300"
                        trigger="click"
                      >
                        <el-form
                          :model="addAddressForm"
                          :rules="addressRules"
                          ref="addAddressForm"
                          label-width="80px"
                          style="padding-right: 0.33rem"
                        >
                          <el-form-item label="办理人" prop="doner_id">
                            <el-select
                              v-model="addAddressForm.doner_id"
                              placeholder="请选择"
                              size="mini"
                              @click.native="loadAdminUser_a"
                              filterable
                              style="width: 100%"
                              clearable
                            >
                              <el-option
                                v-for="item in adminUserOptions_a"
                                :key="item.id"
                                :label="item.username"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <div
                          style="
                            margin-top: 0.15rem;
                            text-align: right;
                            padding-right: 0.33rem;
                          "
                        >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="saveChange('addAddressForm', scope.row.id)"
                            >保存
                          </el-button>
                        </div>
                        <i
                          slot="reference"
                          style="
                            cursor: pointer;
                            font-size: 0.38rem;
                            color: #409eff;
                          "
                          class="el-icon-circle-plus-outline"
                        ></i>
                      </el-popover>
                    </el-tooltip>
                  </span> -->
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="分配超时"
                      placement="top"
                    >
                      <i
                        class="el-icon-warning"
                        style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"
                      ></i>
                    </el-tooltip>
                  </span>
                </span>
                <span v-else>
                  <span>
                    {{ scope.row.donner.username }}
                  </span>
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="分配超时"
                      placement="top"
                    >
                      <i
                        class="el-icon-warning"
                        style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"
                      ></i>
                    </el-tooltip>
                  </span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="donner_w.username" label="外勤办理人" width="120">
            <template slot-scope="scope">
              <div v-if="!scope.row.overTime">
                <span v-if="!scope.row.donner_w && scope.row.type === 'w'">
                  <!-- <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="点击添加办理人(外勤)"
                      placement="top"
                    >
                      <el-popover
                        placement="left-start"
                        width="300"
                        trigger="click"
                      >
                        <el-form
                          :model="addAddressFormW"
                          :rules="addressRules"
                          ref="addAddressFormW"
                          label-width="100px"
                          style="padding-right: 0.31rem"
                        >
                          <el-form-item label="办理人(外勤)" prop="doner_id_w">
                            <el-select
                              v-model="addAddressFormW.doner_id_w"
                              placeholder="请选择"
                              size="mini"
                              @click.native="loadAdminUser_a_w"
                              filterable
                              style="width: 100%"
                              clearable
                            >
                              <el-option
                                v-for="item in adminUserOptions_a_w"
                                :key="item.id"
                                :label="item.username"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <div
                          style="
                            margin-top: 0.15rem;
                            text-align: right;
                            padding-right: 0.31rem;
                          "
                        >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="
                              saveChange_aw('addAddressFormW', scope.row.id)
                            "
                            >保存
                          </el-button>
                        </div>
                        <i
                          slot="reference"
                          style="
                            cursor: pointer;
                            font-size: 0.38rem;
                            color: #409eff;
                          "
                          class="el-icon-circle-plus-outline"
                        ></i>
                      </el-popover>
                    </el-tooltip>
                  </span> -->
                </span>
                <span v-if="scope.row.donner_w">{{ scope.row.donner_w.username }}</span>
              </div>
              <div v-if="scope.row.overTime">
                <span v-if="!scope.row.donner_w && scope.row.type === 'w'">
                  <!-- <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="点击添加办理人(外勤)"
                      placement="top"
                    >
                      <el-popover
                        placement="left-start"
                        width="300"
                        trigger="click"
                      >
                        <el-form
                          :model="addAddressFormW"
                          :rules="addressRules"
                          ref="addAddressFormW"
                          label-width="100px"
                          style="padding-right: 0.31rem"
                        >
                          <el-form-item label="办理人(外勤)" prop="doner_id_w">
                            <el-select
                              v-model="addAddressFormW.doner_id_w"
                              placeholder="请选择"
                              size="mini"
                              @click.native="loadAdminUser_a_w"
                              filterable
                              style="width: 100%"
                              clearable
                            >
                              <el-option
                                v-for="item in adminUserOptions_a_w"
                                :key="item.id"
                                :label="item.username"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <div
                          style="
                            margin-top: 0.15rem;
                            text-align: right;
                            padding-right: 0.31rem;
                          "
                        >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="
                              saveChange_aw('addAddressFormW', scope.row.id)
                            "
                            >保存
                          </el-button>
                        </div>
                        <i
                          slot="reference"
                          style="
                            cursor: pointer;
                            font-size: 0.38rem;
                            color: #409eff;
                          "
                          class="el-icon-circle-plus-outline"
                        ></i>
                      </el-popover>
                    </el-tooltip>
                  </span> -->
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="分配超时"
                      placement="top"
                    >
                      <i
                        class="el-icon-warning"
                        style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"
                      ></i>
                    </el-tooltip>
                  </span>
                </span>
                <span v-if="scope.row.donner_w">
                  <span>{{ scope.row.donner_w.username }}</span>
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="分配超时"
                      placement="top"
                    >
                      <i
                        class="el-icon-warning"
                        style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"
                      ></i>
                    </el-tooltip>
                  </span>
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="urge_count" label="催办次数" width="120">
            <template slot-scope="scope">
              <div style="padding: 0.28rem 0" v-if="scope.row.urge_count > 0">
                <el-badge :value="scope.row.urge_count" class="item">
                  <el-button size="mini" @click="openUrgeCount(scope.row.urges)"
                    >催办次数</el-button
                  >
                </el-badge>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="feed_count" label="反馈次数" width="80">
          </el-table-column>
          <el-table-column prop="feed[0].created_at" label="最后一次反馈时间" width="160">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="点击查看"
                placement="top"
                v-if="scope.row.feed.length > 0"
              >
                <el-popover placement="right" width="300" trigger="click">
                  <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="10">反馈人:</el-col>
                    <el-col :span="14" style="font-weight: normal">
                      {{ scope.row.feed[0].feedbacker }}
                    </el-col>
                  </el-row>
                  <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="10">反馈内容:</el-col>
                    <el-col :span="14" style="font-weight: normal">
                      {{ scope.row.feed[0].feedback }}
                    </el-col>
                  </el-row>
                  <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="10">预计完成时间:</el-col>
                    <el-col :span="14" style="font-weight: normal">
                      {{ scope.row.feed[0].es_time }}
                    </el-col>
                  </el-row>
                  <i
                    slot="reference"
                    style="cursor: pointer; font-size: 0.28rem; color: #409eff"
                    >{{ scope.row.feed[0].created_at }}</i
                  >
                </el-popover>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="type_name" label="服务类型" width="100">
          </el-table-column>
          <!-- <el-table-column prop="order_num" label="订单号" width="190">
            <template slot-scope="scope">
              <span v-if="scope.row.order_num">
                <el-link
                  style="color: #409eff"
                  @click="
                    handleOrderInfo(
                      scope.row.orderId,
                      scope.row.company.company_name
                    )
                  "
                  >{{ scope.row.order_num }}</el-link
                >
              </span>
              <span style="color: #f56c6c" v-else>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="点击绑定订单"
                  placement="top"
                >
                  <el-popover
                    @hide="clearSelf"
                    placement="bottom"
                    width="300"
                    trigger="click"
                  >
                    <el-input
                      v-model="table_OrderData"
                      size="mini"
                      placeholder="输入订单号绑定订单"
                    ></el-input>
                    <div style="margin-top: 0.15rem; text-align: right">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="bindOrderNum(scope.row.id)"
                        >保存</el-button
                      >
                    </div>
                    <span
                      slot="reference"
                      style="cursor: pointer; color: #f56c6c"
                      >无订单号</span
                    >
                  </el-popover>
                </el-tooltip>
              </span>
            </template>
          </el-table-column> -->
          <el-table-column prop="title_name" label="事项" width="230"> </el-table-column>
          <el-table-column prop="diser.username" label="分配人" width="150">
            <template slot-scope="scope">
              <p v-if="scope.row.diser">{{ scope.row.diser.username }}</p>
              <p>{{ scope.row.distribute_at }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="progress" label="进度" width="150">
            <template slot-scope="scope">
              <div v-if="!scope.row.overTimeD">
                <p>{{ scope.row.progress }}</p>
                <p v-if="scope.row.progress === '已完成'">
                  {{ scope.row.done_at }}
                </p>
                <!-- <p v-if="scope.row.screen.length > 0">
                  <el-link
                    style="color: #409eff"
                    @click.native="openImageDrawer(scope.row.screen)"
                    ><span>相关截图/文件</span>
                  </el-link>
                </p> -->
              </div>
              <div v-if="scope.row.overTimeD">
                <p>
                  <span>{{ scope.row.progress }}</span>
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="办理超时"
                      placement="top"
                    >
                      <i
                        class="el-icon-warning"
                        style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"
                      ></i>
                    </el-tooltip>
                  </span>
                </p>
                <p v-if="scope.row.progress === '已完成'">
                  {{ scope.row.done_at }}
                </p>
                <!-- <p v-if="scope.row.screen.length > 0">
                  <el-link
                    @click.native="openImageDrawer(scope.row.screen)"
                    style="color: #409eff"
                    >相关截图/文件</el-link
                  >
                </p> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100"> </el-table-column>
          <!-- <el-table-column label="操作" fixed="right" width="220">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="编辑"
                placement="top"
              >
                <el-button
                  @click.native.prevent="openEdit(scope.row)"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                >
                </el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="分配"
                placement="top"
              >
                <el-button
                  @click.native.prevent="openDistribute(scope.row)"
                  type="success"
                  size="mini"
                  icon="el-icon-user"
                  circle
                >
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="" placement="top">
                <template slot="content">
                  <p>催办</p>
                  <p>催办时间间隔为24h</p>
                </template>
                <el-button
                  @click.native.prevent="openUrge(scope.row)"
                  type="danger"
                  size="mini"
                  icon="el-icon-message-solid"
                  circle
                  :disabled="
                    (scope.row.urge.length > 0
                      ? scope.row.urge[0].notTime
                      : false) || scope.row.progress === '已完成'
                  "
                >
                </el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="企业微信群聊天记录"
                placement="top"
              >
                <el-button
                  type="warning"
                  @click="
                    handleWxChatOpen(
                      scope.row.wx_work_chat_com,
                      scope.row.company.company_name
                    )
                  "
                  size="mini"
                  icon="el-icon-s-comment"
                  circle
                  :disabled="scope.row.wx_work_chat_com ? false : true"
                >
                </el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="电话联系记录"
                placement="top"
              >
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-phone-outline"
                  circle
                  @click="handCallLogsOpen(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
          <el-pagination
            @size-change="handleSizeChange_un"
            @current-change="handleCurrentChange_un"
            :current-page.sync="npage_un"
            :page-sizes="[10, 15, 30, 50, 100]"
            :page-size="pageSize_un"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_un"
            background
          >
          </el-pagination>
        </div>
      </div>
    </el-drawer>
    <div style="padding: 0.2rem 0; background-color: #f9fafc">
      <el-row type="flex" justify="center">
        <el-col :span="14">
          <div class="deept">
            <el-steps :active="active" :space="400" align-center finish-status="success">
              <el-step title="步骤 1" description="按条件查询企业或导入Excel查询企业">
              </el-step>
              <el-step title="步骤 2" description="选中需要交接的企业"></el-step>
              <el-step
                title="步骤 3"
                description="选中需要的新的对接人员，然后保存"
              ></el-step>
              <el-step
                title="步骤 4"
                description="保存成功，自动提交审核，审核通过自动完成交接"
              ></el-step>
            </el-steps>
          </div>
        </el-col>
      </el-row>
      <!-- <el-button size="mini" style="margin-top: 12px" @click="next"
      >下一步</el-button
    > -->
      <el-drawer
        title="公司信息"
        :visible.sync="companyInfoDrawer"
        direction="rtl"
        size="50%"
      >
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <el-row>
            <company-info :companyId="companyComId"></company-info>
          </el-row>
        </div>
      </el-drawer>
      <div>
        <el-radio-group v-model="item" size="mini" @change="clearItem">
          <el-radio-button @click.native="chooseMethod" label="1"
            >按条件查询企业</el-radio-button
          >
          <el-radio-button @click.native="chooseMethod" label="2"
            >导入Excel查询企业</el-radio-button
          >
        </el-radio-group>
      </div>
      <div v-if="step1 && item === '1'">
        <!-- <el-tag size="mini">按条件查询企业</el-tag> -->
        <el-form
          ref="chooseForm"
          :model="chooseForm"
          label-width="80px"
          style="padding: 0.2rem 0; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
        >
          <el-form-item label="岗位角色">
            <el-row>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="chooseForm.finance_id"
                  placeholder="请选择财税负责人"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="chooseForm.jizhang_id"
                  placeholder="请选择理票会计"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="chooseForm.tax_id"
                  placeholder="请选择记账报税会计"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="chooseForm.kaipiao_id"
                  placeholder="请选择开票会计"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="chooseForm.kefu_id"
                  placeholder="请选择客服会计"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="chooseForm.business_id"
                  placeholder="请选择业务"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="成立时间">
            <el-row>
              <el-col :span="8">
                <el-date-picker
                  v-model="chooseForm.establish"
                  type="daterange"
                  align="right"
                  size="mini"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                  style="width: 96.5%"
                >
                  >
                </el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="注册区域">
            <el-row>
              <el-col :span="8">
                <el-row>
                  <el-col :span="12">
                    <el-select
                      v-model="chooseForm.area"
                      placeholder="请选择区域"
                      size="mini"
                      clearable
                      filterable
                      @change="selectPark"
                    >
                      <el-option
                        v-for="item in areaOption"
                        :key="item.id"
                        :label="item.areaName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <el-select
                      v-model="chooseForm.park"
                      placeholder="请选择园区"
                      size="mini"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in parkOption"
                        :key="item.id"
                        :label="item.areaName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="纳税规模">
            <el-row>
              <el-col :span="4">
                <el-select
                  v-model="chooseForm.guimo"
                  placeholder="请选择纳税规模"
                  size="mini"
                  filterable
                  clearable
                >
                  <el-option label="空" value="0"> </el-option>
                  <el-option
                    v-for="item in guimoOption"
                    :key="item.id"
                    :label="item.scale_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="报税方式">
            <el-row>
              <el-col :span="6">
                <el-select
                  v-model="chooseForm.fangshi"
                  placeholder="是否零申报"
                  size="mini"
                  clearable
                >
                  <el-option label="未知" value="0"> </el-option>
                  <el-option label="是" value="1"> </el-option>
                  <el-option label="否" value="2"> </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="税控托管">
            <el-row>
              <el-col :span="6">
                <el-select
                  v-model="chooseForm.tuoguan"
                  placeholder="是否有税控托管"
                  size="mini"
                  clearable
                >
                  <el-option label="未知" value="0"> </el-option>
                  <el-option label="无" value="1"> </el-option>
                  <el-option label="有" value="2"> </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="社保">
            <el-row>
              <el-col :span="6">
                <el-select
                  v-model="chooseForm.shebao"
                  placeholder="是否有社保代管"
                  size="mini"
                  clearable
                >
                  <el-option label="未知" value="1"> </el-option>
                  <el-option label="无" value="2"> </el-option>
                  <el-option label="有" value="3"> </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="公积金">
            <el-row>
              <el-col :span="6">
                <el-select
                  v-model="chooseForm.gongjijng"
                  placeholder="是否有公积金代管"
                  size="mini"
                  clearable
                >
                  <el-option label="未知" value="1"> </el-option>
                  <el-option label="无" value="2"> </el-option>
                  <el-option label="有" value="3"> </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-row type="flex" justify="end">
            <el-col :span="3">
              <el-button type="primary" size="mini" @click="doSearch">查询</el-button>
              <el-button type="info" size="mini" @click="resetForm('chooseForm')"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-if="step1 && item === '2'" style="padding-top: 0.1rem; text-align: center">
        <!-- https://weixin.qiyehuo.com/api/handover_examine/import_excel -->
        <!-- api/handover_examine/import_excel -->
        <el-upload
          action="https://weixin.qiyehuo.com/api/handover_examine/import_excel"
          :headers="headers"
          ref="uploadMutiple"
          :show-file-list="false"
          :on-success="getInfo"
        >
          <el-button type="warning" size="mini">导入</el-button>
        </el-upload>
        <p style="margin-top: 0.1rem">
          <span>若无模板,可</span>
          <!-- <el-link style="color: #409EFF;cursor: pointer" v-down="'http://wx.qyh.com/storage/handover_excel_model/导入查询公司.xlsx'">下载导入模板</el-link> -->
          <el-link
            style="color: #409eff; cursor: pointer"
            :href="'https://weixin.qiyehuo.com/storage/handover_excel_model/导入查询公司.xlsx'"
            >下载导入模板</el-link
          >
          <!-- http://wx.qyh.com/storage/handover_excel_model/导入查询公司.xlsx -->

          <!-- <el-link
            style="color: #409eff; cursor: pointer"
            @click="downloadWhiteModel"
            >下载导入模板</el-link
          > -->
        </p>
      </div>
      <div v-if="step2">
        <el-tag size="mini" style="margin-top: 0.2rem">选中需要交接的企业</el-tag>
        <!-- <div v-if="countCompany">共{{ countCompany }}家公司</div> -->
        <div>
          <div style="display: inline-block">共{{ total }}家公司</div>
          <div
            style="
              margin: auto;
              background-color: #409eff;
              color: aliceblue;
              padding: 6px 10px;
              border-radius: 5px;
              display: inline-block;
              margin-left: 0.2rem;
            "
          >
            <label style="cursor: pointer">
              <input type="checkbox" v-model="chooseAll" @change="getAllData" />
              <span>全选</span>
            </label>
          </div>
        </div>
        <div style="padding: 0.2rem 0; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
          <el-table
            border
            ref="companyTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            size="mini"
            @row-click="getSelectId"
            :row-key="getRowKey"
            :reserve-selection="true"
            :header-cell-style="{
              background: '#ecf4ff',
              color: '#333',
              fontWeight: '900',
              fontSize: '0.28rem',
            }"
            @selection-change="getIdforEdit"
          >
            >
            <!-- <el-table-column type="selection" width="55" fixed="left">
            </el-table-column> -->
            <el-table-column
              prop=""
              width="35"
              show-overflow-tooltip
              align="center"
              fixed
            >
              <template slot="header">
                <el-checkbox
                  v-model="companyInput"
                  @change="checkedCompany"
                ></el-checkbox>
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  v-model="companyInputSon[scope.row.id]"
                  @change="companyChange($event, scope.row.id)"
                ></el-checkbox>
                <!-- <input ref="chk" type="checkbox" class="company-check" :data-id="scope.row.id" :name="'chk' + scope.row.id"> -->
                <!-- <el-checkbox @change="companyChange($event, scope.row.id)" v-if="scope.row.company_checked">
                </el-checkbox>
                <el-checkbox @change="companyChange($event, scope.row.id)" v-else>
                </el-checkbox> -->
              </template>
            </el-table-column>
            <el-table-column label="公司" width="250" prop="company_name" fixed="left">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.company_name"
                  style="color: #409eff; font-size: 0.28rem"
                  @click="openCompanyCom(scope.row)"
                >
                  {{ scope.row.company_name }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column
              label="财税负责人"
              width="120"
            >
            <template slot-scope="scope">
              {{ scope.row.leader.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
            </el-table-column>
            <el-table-column
              label="理票会计"
              width="120"
            >
            <template slot-scope="scope">
              {{ scope.row.acc.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
            </el-table-column>
            <el-table-column
              label="记账报税会计"
              width="120"
            >
            <template slot-scope="scope">
              {{ scope.row.advisory.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
            </el-table-column>
            <el-table-column
              label="开票会计"
              width="120"
            >
            <template slot-scope="scope">
              {{ scope.row.invoice.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
            </el-table-column>
            <el-table-column
              label="客服会计"
              width="120"
            >
            <template slot-scope="scope">
              {{ scope.row.ass.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
            </el-table-column>
            <el-table-column label="业务员" width="120">
              <template slot-scope="scope">
              {{ scope.row.dedicated_consultant.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
            </el-table-column>
            <el-table-column prop="address_area" label="区域" width="120">
            </el-table-column>
            <el-table-column
              prop="address_park"
              label="园区"
              width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="是否1-2个月内到期"
              width="150"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-link
                  style="color: #f56c6c"
                  v-if="scope.row.fin_reg && scope.row.fin_reg.inNearTwoMonth"
                  >是</el-link
                >
                <span
                  v-if="scope.row.fin_reg && scope.row.fin_reg.inNearTwoMonth === false"
                  >否</span
                >
                <span
                  style="color: #f56c6c; margin-left: 0.1rem"
                  v-if="scope.row.fin_reg && scope.row.fin_reg.inNearTwoMonth"
                  >{{ scope.row.fin_reg.end_time }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="待办事项是否完成"
              width="140"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-link
                  @click="openUnMatterOvered(scope.row.id)"
                  style="color: #f56c6c"
                  v-if="scope.row.matterOvered !== null && scope.row.matterOvered"
                  >未完成</el-link
                >
                <span v-if="scope.row.matterOvered !== null && !scope.row.matterOvered"
                  >完成</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="是否有企业微信群"
              width="140"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-link style="color: #f56c6c" v-if="scope.row.wx_work_chat">是</el-link>
                <span v-else scope.row.matterOvered>否</span>
              </template>
            </el-table-column>
            <el-table-column prop="" width="280" show-overflow-tooltip align="center">
              <!-- label="是否已检查群内近30天的聊天记录" -->
              <template slot="header">
                <span>
                  <el-checkbox v-model="groupInput" @change="checkedgroup"></el-checkbox>
                  群内人员是否存在被交接人</span
                >
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.wx_work_chat"
                  v-model="groupInputSon[scope.row.id]"
                  @change="groupChange($event, scope.row.id)"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="" width="280" show-overflow-tooltip align="center">
              <!-- label="是否已检查群内近30天的聊天记录" -->
              <template slot="header">
                <span>
                  <el-checkbox v-model="chatInput" @change="checkedChat"></el-checkbox>
                  是否已检查群内近30天的聊天记录</span
                >
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  v-model="chatInputSon[scope.row.id]"
                  @change="chatChange($event, scope.row.id)"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="" width="270" show-overflow-tooltip align="center">
              <!-- label="是否已进行财务报表及报税检查" -->
              <template slot="header">
                <span>
                  <el-checkbox v-model="taxInput" @change="checkedTax"></el-checkbox>
                  是否已进行财务报表及报税检查</span
                >
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  v-model="taxInputSon[scope.row.id]"
                  @change="taxChange($event, scope.row.id)"
                ></el-checkbox>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="2" label="22" show-overflow-tooltip>
          </el-table-column> -->
          </el-table>
          <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="npage"
              :page-sizes="[10, 15, 30, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div style="text-align: right">
          <el-button size="mini" type="warning" style="margin-top: 12px" @click="dopre"
            >上一步</el-button
          >
          <el-button type="primary" size="mini" style="margin-top: 12px" @click="donext"
            >下一步</el-button
          >
        </div>
      </div>
      <div v-if="step3">
        <el-tag size="mini" style="margin-top: 0.2rem">已选择的企业</el-tag>
        <el-table
          ref="companytTable"
          :data="areData"
          tooltip-effect="dark"
          style="width: 100%"
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
          border
        >
          >
          <el-table-column label="公司" width="250" prop="company_name" fixed="left">
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.company_name"
                style="color: #409eff; font-size: 0.28rem"
                @click="openCompanyCom(scope.row)"
              >
                {{ scope.row.company_name }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            label="财税负责人"
            width="120"
          >
          <template slot-scope="scope">
              {{ scope.row.leader.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
          </el-table-column>
          <el-table-column
            label="理票会计"
            width="120"
          >
          <template slot-scope="scope">
              {{ scope.row.acc.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
          </el-table-column>
          <el-table-column
            label="记账报税会计"
            width="120"
          >
          <template slot-scope="scope">
              {{ scope.row.advisory.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
          </el-table-column>
          <el-table-column
            label="开票会计"
            width="120"
          >
          <template slot-scope="scope">
              {{ scope.row.invoice.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
          </el-table-column>
          <el-table-column
            label="客服会计"
            width="120"
          >
          <template slot-scope="scope">
              {{ scope.row.ass.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
          </el-table-column>
          <el-table-column label="业务员" width="120">
            <template slot-scope="scope">
              {{ scope.row.dedicated_consultant.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}
            </template>
          </el-table-column>
          <el-table-column prop="address_area" label="区域" width="120">
          </el-table-column>
          <el-table-column
            prop="address_park"
            label="园区"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column prop="2" label="22" show-overflow-tooltip>
          </el-table-column> -->
        </el-table>
        <el-tag size="mini" style="margin-top: 0.2rem">选择新的对接人员</el-tag>
        <el-form
          ref="editForm"
          :model="editForm"
          label-width="80px"
          style="padding: 0.2rem 0; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
        >
          <el-form-item label="岗位角色">
            <el-row>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="editForm.finance_id"
                  placeholder="请选择财税负责人"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="editForm.jizhang_id"
                  placeholder="请选择理票会计"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
                
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="editForm.tax_id"
                  placeholder="请选择记账报税会计"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="editForm.kaipiao_id"
                  placeholder="请选择开票会计"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>

              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="editForm.kefu_id"
                  placeholder="请选择客服会计"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="4">
                <el-cascader
                  style="width: 100%"
                  v-model="editForm.business_id"
                  placeholder="请选择业务"
                  :options="financeOptionConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
            </el-row>
          </el-form-item>
          <el-row type="flex" justify="end">
            <el-col :span="3">
              <el-button type="warning" size="mini" @click="beforeSave">上一步</el-button>
              <el-button type="primary" size="mini" @click="doSave">保存</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-if="step4">
        <el-tag size="mini" style="margin-top: 0.2rem">保存成功</el-tag>
        <el-alert title="提交成功" type="success" center :closable="false" show-icon>
        </el-alert>
      </div>
    </div>
  </div>
</template>
<script>
import CompanyInfo from "common/CompanyInfo";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import Vue from "vue";

export default {
  name: "Handover",
  components: { CompanyInfo },
  data() {
    Vue.directive("down", {
      inserted: (el, binding) => {
        el.style.cssText = "cursor: pointer;color:write;";
        el.addEventListener("click", () => {
          // console.log(binding.value)
          let link = document.createElement("a");
          let image = document.createElement("image");
          let url = binding.value;
          let downloadName = url.slice(url.lastIndexOf("/") + 1);
          // console.log(downloadName);
          // 这里是将url转成blob地址，
          image.setAttribute("crossOrigin", "anonymous"); // 这句可以解决跨域问题
          fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              link.href = URL.createObjectURL(blob);
              // console.log(link.href)
              link.download = downloadName;
              document.body.appendChild(link);
              link.click();
            });
        });
      },
    });
    return {
      chooseAll: null,
      companyInput: false,
      urgeCountDrawer: false,
      urgeCountData: [],
      //
      unMatterOveredId: "",
      pageSize_un: 10,
      total_un: 0,
      npage_un: 1,
      unMatterOveredData: [],
      unMatterOveredDrawer: false,
      dialogFormVisible: false,
      importNum: "",
      importIds: [],
      importArr: [],
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      chooseMethod() {
        if (this.step4) {
          this.step4 = false;
          this.step1 = true;
        }
        // if (val === 1) {
        //   this.searchArr.pay = ''
        // }
      },
      item: "1",
      groupInput: false,
      multipleSelection: [],
      remberId: [],
      chatCompanyIds: [],
      taxCompanyIds: [],
      companyCompanyIds: [],
      groupCompanyIds: [],
      taxInput: false,
      chatInputSon: [],
      companyInputSon: [],
      groupInputSon: [],
      taxInputSon: [],
      chatInput: false,
      pageSize: 10,
      nowPage: 1,
      total: 0,
      npage: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      needRow: "",
      active: 0,
      chooseForm: {
        finance_id: null,
        jizhang_id: null,
        tax_id: null,
        kaipiao_id: null,
        kefu_id: null,
        business_id: '',
        establish: "",
        area: "",
        park: "",
        guimo: "",
        fangshi: "",
        tuoguan: "",
        shebao: "",
        gongjijng: "",
      },
      editForm: {
        finance_id: null,
        jizhang_id: null,
        tax_id: null,
        kaipiao_id: null,
        kefu_id: null,
        business_id: '',
      },
      needRef: "",
      areData: [],
      searchLoading: false,
      financeOption: [],
      // editFinanceOption: [],
      // jizhangOption: [],
      // editJizhangOption: [],
      // taxOption: [],
      // editTaxOption: [],
      // kaipiaoOption: [],
      // editKaipiaoOption: [],
      // kefuOption: [],
      // editKefuOption: [],
      // businessOption: [],
      // editBusinessOption: [],
      areaOption: [],
      parkOption: [],
      guimoOption: [],
      fangshiOption: [],
      tuoguanOption: [],
      shebaoOption: [],
      gongjijingOption: [],
      tableData: [],
      needIds: "",
      countCompany: null,
      companyInfoDrawer: false,
      companyComId: null,
      needObj: "",
      step1: true,
      step2: false,
      step3: false,
      step4: false,
      additionalData: { value: "0", label: "空" },
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
    financeOptionConvert() {
      return [...this.financeOption, this.additionalData];
    },
  },
  methods: {
    exportFail() {
      this.$axios
        .post(
          "api/handover_examine/export_excel",
          {
            company_arr: this.importArr,
          },
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "导入失败.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    openUrgeCount(data) {
      this.urgeCountData = data;
      this.urgeCountData.reverse();
      this.urgeCountDrawer = true;
    },
    //
    closeUnMatterOveredDrawer() {
      this.unMatterOveredId = "";
      this.unMatterOveredData = [];
    },
    getUnMatterOveredData() {
      if (!this.unMatterOveredId) return false;
      this.$axios
        .get(
          "api/handover_examine/get_matter_un?page" +
            this.npage_un +
            "&perPage=" +
            this.pageSize_un +
            "&cid=" +
            this.unMatterOveredId
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.unMatterOveredData = data.data.data;
            this.total_un = data.data.total;
          }
        })
        .catch();
    },
    openUnMatterOvered(id) {
      this.unMatterOveredId = id;
      this.getUnMatterOveredData();
      this.unMatterOveredDrawer = true;
    },
    clearItem(val) {
      if (val === "2") {
        this.resetForm();
      } else {
        this.importIds = [];
      }
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    goOnSearch() {
      this.doSearch();
      this.dialogFormVisible = false;
    },
    downloadWhiteModel() {
      this.$axios
        .post("api/handover_examine/download_white_model", {
          responseType: "blob",
        })
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "导入查询公司.csv";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    getInfo(res) {
      if (res.code === 1) {
        this.importNum = res.data.num;
        this.importIds = res.data.ids;
        this.importArr = res.data.arr;
        if (res.data.arr.length !== 0) {
          this.dialogFormVisible = true;
        } else {
          this.doSearch();
        }
      }
    },
    taxChange(val, id) {
      if (val) {
        if (this.taxCompanyIds.indexOf(id) === -1) {
          this.taxCompanyIds.push(id);
        }
      } else {
        if (this.taxCompanyIds.indexOf(id) !== -1) {
          this.taxCompanyIds.splice(this.taxCompanyIds.indexOf(id), 1);
        }
      }
    },
    companyChange(val, id) {
      if (val) {
        if (this.companyCompanyIds.indexOf(id) === -1) {
          this.companyCompanyIds.push(id);
        }
      } else {
        if (this.companyCompanyIds.indexOf(id) !== -1) {
          this.companyCompanyIds.splice(this.companyCompanyIds.indexOf(id), 1);
        }
      }
    },
    chatChange(val, id) {
      if (val) {
        if (this.chatCompanyIds.indexOf(id) === -1) {
          this.chatCompanyIds.push(id);
        }
      } else {
        if (this.chatCompanyIds.indexOf(id) !== -1) {
          this.chatCompanyIds.splice(this.chatCompanyIds.indexOf(id), 1);
        }
      }
    },
    groupChange(val, id) {
      if (val) {
        if (this.groupCompanyIds.indexOf(id) === -1) {
          this.groupCompanyIds.push(id);
        }
      } else {
        if (this.groupCompanyIds.indexOf(id) !== -1) {
          this.groupCompanyIds.splice(this.groupCompanyIds.indexOf(id), 1);
        }
      }
    },
    checkedChat1(val) {
      var cArr = [];
      this.chatInputSon = [];
      this.tableData.forEach((item) => {
        this.chatInputSon.forEach((i) => {
          if (Object.keys(i).indexOf(item.id) === -1) {
            this.chatInputSon.push(item.id);
          }
        });
        if (val) {
          cArr.push(item.id);
          this.chatInputSon[item.id] = true;
        } else {
          this.chatInputSon[item.id] = false;
          cArr = [];
        }
      });
      this.chatCompanyIds = cArr;
      console.log(this.chatCompanyIds);
    },
    checkedChat(val) {
      var cArr = [];
      this.tableData.forEach((item) => {
        if (val) {
          cArr.push(item.id);
          Vue.set(this.chatInputSon, item.id, true);
        } else {
          Vue.set(this.chatInputSon, item.id, false);
          cArr = [];
        }
      });
      this.chatCompanyIds = cArr;
    },
    checkedTax1(val) {
      var tArr = [];
      this.taxInputSon = [];
      this.tableData.forEach((item) => {
        this.taxInputSon.forEach((i) => {
          if (Object.keys(i).indexOf(item.id) === -1) {
            this.taxInputSon.push(item.id);
          }
        });
        if (val) {
          tArr.push(item.id);
          this.taxInputSon[item.id] = true;
        } else {
          this.taxInputSon[item.id] = false;
          tArr = [];
        }
      });
      this.taxCompanyIds = tArr;
    },
    checkedTax(val) {
      var tArr = [];
      this.tableData.forEach((item) => {
        if (val) {
          tArr.push(item.id);
          Vue.set(this.taxInputSon, item.id, true);
        } else {
          Vue.set(this.taxInputSon, item.id, false);
          tArr = [];
        }
      });
      this.taxCompanyIds = tArr;
    },
    checkedCompany1(val) {
      var cArr = [];
      this.companyInputSon = [];
      this.tableData.forEach((item) => {
        this.companyInputSon.forEach((i) => {
          if (Object.keys(i).indexOf(item.id) === -1) {
            this.companyInputSon.push(item.id);
          }
        });
        if (val) {
          cArr.push(item.id);
          this.companyInputSon[item.id] = true;
        } else {
          this.companyInputSon[item.id] = false;
          cArr = [];
        }
      });
      this.companyCompanyIds = cArr;
    },
    checkedCompany(val) {
      var cArr = [];
      this.companyInputSon = [];
      this.tableData.forEach((item) => {
        if (val) {
          cArr.push(item.id);
          Vue.set(this.companyInputSon, item.id, true);
        } else {
          cArr = [];
          Vue.set(this.companyInputSon, item.id, false);
        }
      });
      this.companyCompanyIds = cArr;
    },
    checkedgroup1(val) {
      var gArr = [];
      this.groupInputSon = [];
      this.tableData.forEach((item) => {
        this.groupInputSon.forEach((i) => {
          if (Object.keys(i).indexOf(item.id) === -1) {
            this.groupInputSon.push(item.id);
          }
        });
        if (val) {
          gArr.push(item.id);
          this.groupInputSon[item.id] = true;
        } else {
          this.groupInputSon[item.id] = false;
          gArr = [];
        }
      });
      this.groupCompanyIds = gArr;
    },
    checkedgroup(val) {
      var gArr = [];
      this.tableData.forEach((item) => {
        if (val) {
          gArr.push(item.id);
          Vue.set(this.groupInputSon, item.id, true);
        } else {
          Vue.set(this.groupInputSon, item.id, false);
          gArr = [];
        }
      });
      this.groupCompanyIds = gArr;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize = val;
      this.doSearch();
    },
    handleSizeChange_un(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize_un = val;
      this.getUnMatterOveredData();
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.doSearch();
    },
    handleCurrentChange_un(val) {
      this.npage_un = val;
      this.getUnMatterOveredData();
    },
    next() {
      if (this.active++ > 3) this.active = 0;
    },
    searchRemoteFinance(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchFinance(query);
        }, 200);
      } else {
        this.searchCategories = [];
      }
    },
    searchFinance(query) {
      this.$axios
        .get("api/cloudfile/getitem", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data;
          }
        })
        .catch();
    },
    getRowKey(row) {
      return row.id;
    },
    getIdforEdit(val) {
      this.multipleSelection = val;
      this.needIds = [];
      var obj = val.map((item) => {
        return item;
      });
      var ids = val.map((item) => {
        if (!this.remberId.includes(item.id)) {
          this.remberId.push(item.id);
        }
        return item.id;
      });
      if (ids.length === 0) {
        return false;
      }
      this.needObj = obj;
      this.needIds = ids;
    },
    loadUser() {
      this.$axios
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.financeOption = data.data;
            // this.jizhangOption = data.data
            // this.taxOption = data.data
            // this.kaipiaoOption = data.data
            // this.kefuOption = data.data
            // this.businessOption = data.data

            // this.editFinanceOption = data.data
            // this.editJizhangOption = data.data
            // this.editTaxOption = data.data
            // this.editKaipiaoOption = data.data
            // this.editKefuOption = data.data
            // this.editBusinessOption = data.data
          }
        })
        .catch();
    },
    newArr(oldData, newData) {
      // 去重
      let arr1 = new Set(oldData); // 原数组
      let arr2 = new Set(newData); // 新数组
      let List = [];
      // for of：循环数组的值
      for (let k of arr2) {
        // 对比数组每一项，没有的就添加到空数组
        if (!arr1.has(k)) {
          List.push(k);
        }
      }
      return List; // 这里拿到了差值数据返回出去
    },
    getSelectId(val) {
      // alert(val.id)
    },
    toggleSelection() {
      let diffArr = this.newArr(this.needIds, this.remberId);
      console.log("diff", diffArr);
      console.log("原", this.remberId);
      // return false
      // this.remberId.map((item, index, arr) => {
      //   if (diffArr.includes(item)) {
      //     this.remberId.splice(index, 1)
      //   }
      // })
      // this.$nextTick(() => {
      //   if (this.remberId.length > 0) {
      //     this.tableData.forEach(row => {
      //       if (this.remberId.includes(row.id)) {
      //         this.$refs.companyTable.toggleRowSelection(row)
      //       }
      //     })
      //   } else {
      //     this.$refs.companyTable.clearSelection()
      //   }
      // })
    },
    // getRemberId (data) {
    //   const a = []
    //   data.map(item => {
    //     if (this.remberId.includes(item.id)) {
    //       a.push(item)
    //     }
    //   })
    //   this.toggleSelection(a)
    // },
    doSearch(e) {
      if (this.item === "1") {
        const fields = [
          "finance_id",
          "jizhang_id",
          "tax_id",
          "kaipiao_id",
          "kefu_id",
          "business_id",
        ];
        let allFieldsNull = true; // flag

        // console.log(this.chooseForm);return;
        for (let field of fields) {
          const value = this.chooseForm[field];
          if (value) {
            allFieldsNull = false;
            this.chooseForm[field] = value;
            // if (value.length === 1) {
            //   this.chooseForm[field] = Number(value[0]);
            // } else {
            //   this.chooseForm[field] = value[1];
            // }
          }
        }
        if (allFieldsNull) {
          this.$message.warning("未选择岗位角色！");
          return false;
        }
      }
      this.step1 = false;
      this.step2 = true;
      this.active = 1;
      this.chooseForm.importIds = this.importIds;

      this.$axios
        .post(
          "api/customer/handover?page=" + this.npage + "&perPage=" + this.pageSize,
          this.chooseForm
        )
        .then(({ data }) => {
          if (data.code === 1) {
            // this.importIds = []
            this.total = data.data.total;
            this.tableData = data.data.data;
            this.toggleSelection();
            // this.getRemberId(this.tableData)
            // this.countCompany = this.tableData.length
            this.countCompany = data.data.total;
          } else {
            this.$message.warning(data.msg);
          }
        })
        .catch();
    },

    getAll() {
      this.$axios
        .post(
          "api/customer/handover/all?page=" + this.npage + "&perPage=" + this.pageSize,
          this.chooseForm
        )
        .then(({ data }) => {
          if (data.code === 1) {
            // this.importIds = []
            // this.total = data.data.total
            // this.tableData = data.data.data
            this.editForm.ids = data.data;
            // this.toggleSelection()
            // this.getRemberId(this.tableData)
            // this.countCompany = this.tableData.length
            // this.countCompany = data.data.total
          } else {
            this.$message.warning(data.msg);
          }
        })
        .catch();
    },

    saveData() {
      // formater
      const fields = [
        "finance_id",
        "jizhang_id",
        "tax_id",
        "kaipiao_id",
        "kefu_id",
        "business_id",
      ];
      
      for (let field of fields) {
        const value = this.editForm[field];
        if (value) {
          this.editForm[field] = value;
        }
      }

      this.$axios
        .post("api/handover/dosave", {
          editForm: this.editForm,
          obj: this.needObj,
          tax: this.taxCompanyIds,
          chat: this.chatCompanyIds,
          group: this.groupCompanyIds,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.active = 4;
            this.step3 = false;
            this.step4 = true;
            this.editForm.finance_id = null;
            this.editForm.jizhang_id = null;
            this.editForm.tax_id = null;
            this.editForm.kaipiao_id = null;
            this.editForm.kefu_id = null;
            this.editForm.business_id = '';
            this.tableData = [];
            this.countCompany = null;
            this.companyCompanyIds = [];
            this.importIds = [];
          } else {
            this.$message.error(data.msg);
            this.active = 3;
          }
        })
        .catch();
    },
    resetForm() {
      this.chooseForm.finance_id = null;
      this.chooseForm.jizhang_id = null;
      this.chooseForm.tax_id = null;
      this.chooseForm.kaipiao_id = null;
      this.chooseForm.kefu_id = null;
      this.chooseForm.business_id = '';
      this.chooseForm.fangshi = null;
      this.chooseForm.tuoguan = null;
      this.chooseForm.shebao = null;
      this.chooseForm.gongjijng = null;
      this.chooseForm.establish = null;
      this.chooseForm.area = null;
      this.chooseForm.park = null;
      this.chooseForm.guimo = null;
    },
    loadArea() {
      this.$axios
        .get("api/handover/area")
        .then(({ data }) => {
          if (data.code === 1) {
            this.areaOption = data.data;
          }
        })
        .catch();
    },
    selectPark(val) {
      this.parkOption = [];
      this.chooseForm.park = "";
      this.$axios
        .get("api/handover/park?pid=" + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.parkOption = data.data;
          }
        })
        .catch();
    },
    loadGuimo() {
      this.$axios
        .get("api/handover/guimo")
        .then(({ data }) => {
          if (data.code === 1) {
            this.guimoOption = data.data;
          }
        })
        .catch();
    },
    beforeSave() {
      this.tableData.map((item) => {
        if (this.needIds.indexOf(item.id) !== -1) {
          setTimeout(() => {
            this.$refs.companyTable.toggleRowSelection(item, true);
          });
        }
      });
      this.step3 = false;
      this.step2 = true;
      this.active = 1;
    },
    doSave() {
      // if (this.needIds.length === 0) {
      if (this.companyCompanyIds === 0) {
        this.$message.warning("未选择需要交接的企业！");
        return false;
      }
      var arr = Object.values(this.editForm);
      var res = [];
      arr.map((item) => {
        if (item !== null) res.push(item);
      });
      if (res.length === 0) {
        this.$message.warning("未选择新的对接人员！");
        return false;
      }
      this.active = 3;
      // this.editForm.ids = this.needIds
      if (this.chooseAll) {
        this.$axios
          .post(
            "api/customer/handover/all?page=" + this.npage + "&perPage=" + this.pageSize,
            this.chooseForm
          )
          .then(({ data }) => {
            if (data.code === 1) {
              // this.importIds = []
              // this.total = data.data.total
              // this.tableData = data.data.data
              this.editForm.ids = data.data;
              // this.toggleSelection()
              // this.getRemberId(this.tableData)
              // this.countCompany = this.tableData.length
              // this.countCompany = data.data.total
              this.saveData();
            } else {
              this.$message.warning(data.msg);
            }
          })
          .catch();
      } else {
        this.editForm.ids = this.companyCompanyIds;
        this.saveData();
      }
    },
    openCompanyCom(row) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyComId = row.id;
      });
    },
    openCompanyCom_a(row) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyComId = row.company_id;
      });
    },
    dopre() {
      this.npage = 1;
      this.chatCompanyIds = [];
      this.taxCompanyIds = [];
      this.groupCompanyIds = [];
      this.chatInput = false;
      this.taxInput = false;
      this.chatInputSon = [];
      this.taxInputSon = [];
      this.needIds = [];
      this.active = 0;
      this.step2 = false;
      this.step1 = true;
    },
    donext() {
      // console.log(this.companyCompanyIds)
      // if (this.needIds.length === 0) {
      if (this.chooseAll) {
        this.areData = this.tableData;
      } else {
        if (this.companyCompanyIds.length === 0) {
          this.$message.warning("未选择需要交接的企业！");
          return false;
        }
        this.$axios
          .get("api/handover/arelist", {
            params: {
              // ids: this.needIds
              ids: this.companyCompanyIds,
            },
          })
          .then(({ data }) => {
            if (data.code === 1) {
              this.areData = data.data;
            }
          })
          .catch();
      }
      this.active = 2;
      this.step2 = false;
      this.step3 = true;
    },
    getAllData(val) {},
  },
  mounted() {
    this.loadUser();
    this.loadArea();
    this.loadGuimo();
  },
};
</script>
<style scoped>
.handover {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.deept >>> .el-step__title.is-success {
  color: #303133 !important;
}

.deept >>> .el-step__head.is-success {
  color: #303133 !important;
  border-color: #303133 !important;
}

.deept >>> .el-step__description.is-success {
  color: #303133 !important;
}

.deept >>> .el-step__title.is-process {
  font-weight: 700;
  color: #67c23a !important;
}

.deept >>> .el-step__head.is-process {
  color: #67c23a !important;
  border-color: #67c23a !important;
}

.deept >>> .el-step__description.is-process {
  color: #67c23a !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/handover/Handover.vue